import { useContext } from 'react'
import { ToastContext } from '../components/UI/Toast/ToastContext'

export const useToast = () => useContext(ToastContext)